import style from "./Badge.module.css";
import { useTranslation } from "react-i18next";

function Bedge() {
	const { t } = useTranslation();

	return (
		<div className={style.badge}>
			<span>{t("common:plan.premium")}</span>
		</div>
	);
}

export default Bedge;
